import { nextTick } from "vue";

import { ref } from "vue";

import { Ref } from "vue";
import { Message } from "../type";
import db from "./db";

const PAGE_SIZE = 20;

interface UseLoadHistoryProps {
  messageListRef: Ref<HTMLUListElement | null>;
  messageList: Ref<Message[]>;
}

export const useLoadHistory = (props: UseLoadHistoryProps) => {
  const lastLoadedId = ref<number | null>(null);
  const isAtTop = ref(false);
  const historyLoading = ref<boolean | undefined>(false);

  const onLoadHistory = async () => {
    const listDom = props.messageListRef.value;

    if (!listDom) return;

    const prevScrollHeight = listDom.scrollHeight || 0;
    const count = await db.messageList.count();
    let rows: Message[] = [];

    if (lastLoadedId.value === null) {
      // 第一次加载
      rows = await db.messageList.reverse().limit(PAGE_SIZE).toArray();
    } else {
      // 加载更早一页
      rows = await db.messageList
        .where("id")
        .below(lastLoadedId.value)
        .limit(PAGE_SIZE)
        .toArray();
    }
    rows.sort((a, b) => a.date - b.date);
    historyLoading.value = false;

    if (!rows.length) {
      historyLoading.value = undefined;
      return;
    }

    // 记录分页锚点
    lastLoadedId.value = rows[0].id;

    props.messageList.value = [
      ...rows.map((item) => ({
        ...item,
        goodsList: item.goodsList ? JSON.parse(item.goodsList as any) : [],
      })),
      ...props.messageList.value,
    ];

    historyLoading.value = false;
    const excludesGreetingMessageList = props.messageList.value.length - 1;
    if (excludesGreetingMessageList >= count) {
      historyLoading.value = undefined;
    }

    // 等 DOM 更新后调整 scrollTop（保持位置）
    await nextTick();

    const newScrollHeight = listDom.scrollHeight || 0;
    const scrollDelta = newScrollHeight - prevScrollHeight;

    listDom.scrollTop += scrollDelta; // 保持“刚加载那一页底部”
  };

  return {
    onLoadHistory,
    historyLoading,
    isAtTop,
  };
};
